var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDarSavedQuestion = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12,
  height: 16,
  viewBox: "0 0 12 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10.375 0H1.625C1.29348 0 0.975537 0.131696 0.741116 0.366116C0.506696 0.600537 0.375 0.918479 0.375 1.25V15C0.375055 15.1115 0.404959 15.221 0.461608 15.3171C0.518256 15.4132 0.599586 15.4924 0.697156 15.5464C0.794726 15.6005 0.904983 15.6274 1.01648 15.6245C1.12798 15.6215 1.23666 15.5888 1.33125 15.5297L6 12.6117L10.6695 15.5297C10.7641 15.5886 10.8727 15.6212 10.9841 15.624C11.0955 15.6268 11.2056 15.5998 11.303 15.5458C11.4005 15.4918 11.4817 15.4127 11.5383 15.3167C11.5949 15.2208 11.6249 15.1114 11.625 15V1.25C11.625 0.918479 11.4933 0.600537 11.2589 0.366116C11.0245 0.131696 10.7065 0 10.375 0ZM10.375 13.8727L6.33047 11.3453C6.23114 11.2832 6.11636 11.2503 5.99922 11.2503C5.88208 11.2503 5.7673 11.2832 5.66797 11.3453L1.625 13.8727V1.25H10.375V13.8727Z",
  fill: "#6B5CE8"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDarSavedQuestion);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dar_saved_question.eed18cd72a857d2b8cee186cab7bc683.svg";